import { CircularProgress, Stack, Typography } from "@mui/material";

import { useAuth } from "./contexts/AuthContext";
import AppRoutes from "./routes/AppRoutes";

function App() {
  const { isBootstrapping } = useAuth();

  if (isBootstrapping) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={2}
        sx={{ minHeight: "100vh" }}
      >
        <CircularProgress color="secondary" />
        <Typography variant="body2" color="text.secondary">
          Chargement de l'application...
        </Typography>
      </Stack>
    );
  }

  return <AppRoutes />;
}

export default App;
